import React from 'react';
import * as _ from 'lodash';
import clientService from '../services/client';
import querystring from 'querystring';
import NotificationBanner from './boxes/NotificationBanner'
import FreezeBanner from './boxes/FreezeBanner';
import AddSingleEmployeeForm from './forms/AddSingleEmployeeForm';
import AddMultipleEmployeeForm from './forms/AddMultipleEmployeeForm';
import LoadingScreen from './LoadingScreen';
import PageNotFound from './PageNotFound';
import MainContent from './boxes/MainContent';
import PageHeader from './boxes/PageHeader';
import PageBody from './boxes/PageBody';
import { withTranslation } from 'react-i18next';
import { appConfig } from '../config/appConfig';
import i18n from '../i18n';

class AddEmployeeComponent extends React.Component {

    constructor(props) {
        super(props);
        const refCode = querystring.parse(this.props.location.search.substr(1)).refCode;
        this.state = {
            isLoading: false,
            invoiceRefCode: refCode,
            invoicePlans: [],
            isFrozen: false,
            error: {},
            alert: ""
        };
    }

    componentDidMount() {
        this.getPlans();
    };

    getPlans = () => {
        const { invoiceRefCode } = this.state;
        const { accessToken } = this.props.user.credentials;

        this.setLoading(true);

        clientService.getInvoiceByReferenceCode(invoiceRefCode, accessToken, this.props.user.companyInfo.id)
            .then((data) => {
                this.setState({
                    isLoading: false,
                    invoicePlans: data.products,
                    invoiceId: data.id,
                    isFrozen: !!data.is_frozen
                })
            }, (err) => {
                this.setState({
                    error: {
                        message: err.message
                    },
                    alert: ""
                })
            });
    };


    renderInvoiceNotFound() {
        return (
            <MainContent>
                <PageNotFound />
            </MainContent>
        )
    }

    renderLoading() {
        return (
            <MainContent>
                <LoadingScreen />
            </MainContent>
        )
    }

    onSingleFormSubmit = (values) => {
        const { t } = this.props;

        // form is already disabled when frozen; the banner
        // explains why, so just no-op here rather than showing an error toast.
        if (this.state.isFrozen) return;

        if (!values.first_name) {
            return this.setNotification(t("invoices.firstNameErrorMessage"), 'error')
        }
        if (!values.last_name) {
            return this.setNotification(t("invoices.lastNameErrorMessage"), 'error')
        } if (!values.email_address) {
            return this.setNotification(t("invoices.emailErrorMessage"), 'error')
        } if (!values.phone_number) {
            return this.setNotification(t("invoices.phoneNumberErrorMessage"), 'error')
        } if (!values.product_id) {
            return this.setNotification(t("invoices.planSelectionErrorMessage"), 'error')
        }

        this.setLoading(true);

        clientService.addSingleEmployee(
            values.first_name,
            values.last_name,
            values.email_address,
            values.phone_number,
            values.product_id,
            values.no_of_dependant,
            values.access_token,
            values.client_id,
            this.state.invoiceRefCode
        ).then((response) => {
            if (response?.code >= 400) {
                this.setNotification(response?.data?.message, 'error')
                return
            }
            const { name, enrollees_left, message } = response;

            const msg = t("invoices.addSingleEmployeeSuccessMessage", { message, name, enrolleesLeft: enrollees_left });
            this.getPlans();
            this.setNotification(msg, "success");
        }, (err) => {
            this.setNotification(err.response.data.message, "error");
        }).catch(() => {
            this.setNotification(
                t("invoices.formSubmissionError", { contactEmail: appConfig.supportEmailAddress }),
                "error");
        }).finally(() => {
            this.setLoading(false);
        })

    };

    onMultipleFormSubmit = (values) => {
        const { t } = this.props;

        // submit is disabled when frozen; banner explains why.
        if (this.state.isFrozen) return;

        const { access_token, ref_code, client_id } = values;

        this.setLoading(true);

        const formData = new FormData();
        for (let key in values) {
            if (values.hasOwnProperty(key)) {
                if (key === 'file')
                    formData.append(key, values[key][0]); //for selecting the first file in the fileList
                if (['access_token', 'ref_code', 'client_id'].includes(key))
                    continue;
                formData.append(key, values[key]);
            }
        }

        clientService.addMultipleEmployees(formData, access_token, client_id, ref_code)
            .then((response) => {
                const { message } = response?.data;
                const msg = `${message}`;
                this.setLoading(false);
                this.setNotification(msg, "success");
            }, (err) => {
                this.setLoading(false);
                this.setNotification(err.response.data.message, "error");
            }).catch((err) => {
                let errorResponseMessage = err?.response?.data?.message ?
                    err.response.data.message :
                    t("invoices.formSubmissionError", { contactEmail: appConfig.supportEmailAddress })
                this.setLoading(false);
                this.setNotification(
                    errorResponseMessage,
                    "error");
            })
    };

    setLoading = (isLoading) => {
        this.setState({
            isLoading: isLoading
        });
    };

    setNotification = (message, type) => {
        if (type === "success") {
            this.setState({
                alert: message,
                error: null
            })
        } else {
            this.setState({
                error: {
                    message: message
                },
                alert: ""
            })
        }
    };

    closeNotification = () => {
        this.setState({
            alert: "",
            error: null
        })
    }

    render() {

        const { invoiceRefCode, invoicePlans, isLoading, error, alert, isFrozen } = this.state;

        const { user, t } = this.props;


        if (isLoading) return this.renderLoading();


        if (_.isEmpty(invoicePlans)) return this.renderInvoiceNotFound();

        return (
            <MainContent>
                <PageHeader title={t("invoices.addEmployeePageTitle")} />
                <PageBody>
                    {(!_.isEmpty(error) || alert) &&
                        <NotificationBanner
                            title={error ? t("common.errorNotificationTitle") : t("common.defaultNotificationTitle")}
                            message={error ? error.message : alert}
                            type={error ? "error" : "success"}
                            close={this.closeNotification}
                        />
                    }
                    {isFrozen && <FreezeBanner />}
                    <div className="addEmployee">
                        <div className="top-row">
                            <h3 
                                style={{textAlign: i18n.dir() === 'rtl' ? 'right': 'left'}}
                            >
                                {t("invoices.addEmployeePageContentTitle", { referenceCode: invoiceRefCode })}
                            </h3>
                            <p>{t("invoices.addEmployeePageContentSubtitle")}</p>
                        </div>
                        <div className="l-addEmployee">
                            <div className="addEmpForm">
                                <AddSingleEmployeeForm
                                    invoicePlans={invoicePlans}
                                    isFrozen={isFrozen}
                                    onSubmit={this.onSingleFormSubmit} />
                            </div>
                            <div id="or"><p>&nbsp;{t("common.or").toUpperCase()}&nbsp;</p></div>
                            <div className="spreadSheet">
                                <AddMultipleEmployeeForm
                                    refCode={invoiceRefCode}
                                    accessToken={user.credentials.accessToken}
                                    clientId={user.companyInfo.id}
                                    isFrozen={isFrozen}
                                    onSubmit={this.onMultipleFormSubmit} />
                            </div>
                        </div>
                        {/* <div className="addEmployee__invsum">
                            <h2>Invoice Plan Summary:</h2>
                            <table className="dashboard__table">
                                <thead>
                                    <tr>
                                        <th>Plan Description</th>
                                        <th>Total</th>
                                        <th>Added</th>
                                        <th>Remaining</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {invoicePlans.map((plan) => (
                                        <tr key={plan.id}>
                                            <td>{plan.name}</td>
                                            <td>{plan.no_of_enrollees}</td>
                                            <td>{plan.no_of_enrollees - plan.enrollees_left}</td>
                                            <td>{plan.enrollees_left}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                        </div> */}
                    </div>
                </PageBody>
            </MainContent>
        )
    }
}

const AddEmployeeComponentWithTranslation = withTranslation()(AddEmployeeComponent);
export default AddEmployeeComponentWithTranslation;
